import { createAction, props } from '@ngrx/store';

export const setBrowserSupport = createAction(
  '[Shared.System] Set Browser Support',
  props<{ payload: boolean }>()
);

export const setDebug = createAction('[Shared.System] Set Debug', props<{ payload: boolean }>());
